import { useContext } from "react";
import { useQuery } from "react-query";
import { AxiosContext } from "services/axios.context";

export const useReleaseEarnings = (id) => {
  const { client } = useContext(AxiosContext);
  return useQuery(`release-${id}-earnings`, () => {
    console.debug(`release-${id}-earnings retrieved`);

    return client
      .get(`releases/${id}/earnings/`, { params: { detailed: true } })
      .then((resp) => resp.data);
  });
};
